import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { projects } from '../data/projects';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projects.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!project) {
    return (
      <div className="pt-32 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-slate-900 mb-4">Project Not Found</h1>
          <button
            onClick={() => navigate('/portfolio')}
            className="text-green-700 font-semibold hover:text-green-900 transition"
          >
            <i className="fas fa-arrow-left mr-2"></i> Back to Portfolio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20">
      {/* Hero Image */}
      <div className="relative h-[60vh] w-full overflow-hidden">
        <div className="absolute inset-0 bg-slate-900/50 z-10"></div>
        <img src={project.image} className="w-full h-full object-cover" alt={project.title} />
        <div className="absolute inset-0 z-20 flex items-center justify-center">
          <div className="text-center px-4">
            <span className="text-yellow-400 font-bold tracking-widest uppercase text-sm bg-black/30 px-4 py-1 rounded-full backdrop-blur-sm mb-4 inline-block">
              {project.category}
            </span>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 drop-shadow-lg">{project.title}</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 relative z-30 pb-20">
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-slate-100">
          {/* Back Button */}
          <div className="mb-8">
            <button
              onClick={() => navigate('/portfolio')}
              className="text-sm text-slate-500 hover:text-green-700 flex items-center gap-2 transition"
            >
              <i className="fas fa-arrow-left"></i> Back to Portfolio
            </button>
          </div>

          {/* Project Details */}
          <div className="prose prose-lg max-w-none text-slate-600">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">The Challenge</h3>
            <p className="mb-8">{project.challenge}</p>

            <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Solution</h3>
            <p className="mb-8">{project.solution}</p>

            {/* Vision 2030 Context */}
            <div className="bg-green-50 border-l-4 border-green-700 p-6 my-8 rounded-r-lg">
              <h4 className="text-green-900 font-bold text-lg mb-2 flex items-center gap-2">
                <i className="fas fa-flag text-green-700"></i> Saudi Vision 2030 Context
              </h4>
              <p className="text-slate-700 text-sm italic">{project.ksaContext}</p>
            </div>

            {/* Tech Stack */}
            <div className="border-t border-slate-100 pt-8 mt-8">
              <h4 className="font-bold text-slate-900 mb-4 text-sm uppercase tracking-wide">
                Technologies Deployed
              </h4>
              <div className="flex flex-wrap gap-2">
                {project.techStack.map((tech, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-slate-100 text-slate-600 rounded-full text-sm font-medium"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
